export default "__VITE_ASSET__CVixaeUH__"